import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { CreateClienteIntermedioWithUserInput } from "@/lib/validaciones/createClienteIntermedioWithUsuario.validacion";
import { axiosInstance } from "@retro-ia/shared/axios";

export const useRegisterClienteIntermedioWithUsuario = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: CreateClienteIntermedioWithUserInput) => {
      const response = await axiosInstance.post(
        "/clientes-intermedios/with-user",
        data
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["clientesIntermedios"] });
      toast.success("Cliente registrado correctamente");
    },
    onError: (error) => {
      toast.error(
        error instanceof Error
          ? error.message
          : "Ocurrió un error al registrar el cliente."
      );
    },
  });
};
